module.exports = __webpack_public_path__ + "img/037ef77.png";